export default {
  LONGPRESS_DELAY: 500,
}
